<template>
  <header class="header no-auth" v-if="!token">
    <div class="header__container">
      <router-link to="/" class="header__logo">
        <svg
          width="203"
          height="26"
          viewBox="0 0 203 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.9603 15.892C11.9603 15.364 11.9243 14.824 11.8523 14.272C11.8043 13.72 11.6603 13.216 11.4203 12.76C11.1803 12.304 10.8083 11.932 10.3043 11.644C9.82427 11.332 9.14027 11.176 8.25227 11.176C7.36427 11.176 6.66827 11.332 6.16427 11.644C5.68427 11.932 5.32427 12.304 5.08427 12.76C4.84427 13.216 4.68827 13.72 4.61627 14.272C4.56827 14.824 4.54427 15.364 4.54427 15.892V25H0.152266V15.892C0.152266 14.644 0.260266 13.552 0.476266 12.616C0.716266 11.68 1.02827 10.876 1.41227 10.204C1.79627 9.508 2.22827 8.932 2.70827 8.476C3.18827 8.02 3.68027 7.648 4.18427 7.36C5.36027 6.688 6.71627 6.328 8.25227 6.28C9.76427 6.328 11.1083 6.688 12.2843 7.36C12.7883 7.648 13.2803 8.02 13.7603 8.476C14.2643 8.932 14.6963 9.508 15.0563 10.204C15.4403 10.876 15.7523 11.68 15.9923 12.616C16.2323 13.552 16.3523 14.644 16.3523 15.892V25H11.9603V15.892ZM23.7683 15.892C23.7683 15.364 23.7323 14.824 23.6603 14.272C23.6123 13.72 23.4683 13.216 23.2283 12.76C22.9883 12.304 22.6163 11.932 22.1123 11.644C21.6323 11.332 20.9483 11.176 20.0603 11.176C19.1723 11.176 18.4763 11.332 17.9723 11.644C17.4923 11.932 17.1323 12.304 16.8923 12.76C16.6523 13.216 16.4963 13.72 16.4243 14.272C16.3763 14.824 16.3523 15.364 16.3523 15.892V25H11.9603V15.892C11.9603 14.644 12.0683 13.552 12.2843 12.616C12.5243 11.68 12.8363 10.876 13.2203 10.204C13.6043 9.508 14.0363 8.932 14.5163 8.476C14.9963 8.02 15.4883 7.648 15.9923 7.36C17.1683 6.688 18.5243 6.328 20.0603 6.28C21.5723 6.328 22.9163 6.688 24.0923 7.36C24.5963 7.648 25.0883 8.02 25.5683 8.476C26.0723 8.932 26.5043 9.508 26.8643 10.204C27.2483 10.876 27.5603 11.68 27.8003 12.616C28.0403 13.552 28.1603 14.644 28.1603 15.892V25H23.7683V15.892ZM47.2723 13.552C47.3203 13.912 47.3563 14.284 47.3803 14.668C47.4283 15.052 47.4523 15.46 47.4523 15.892V16.54H34.8523C34.9003 16.948 34.9603 17.368 35.0323 17.8C35.1043 18.208 35.2243 18.616 35.3923 19.024C35.6563 19.648 36.0643 20.2 36.6163 20.68C37.1683 21.16 37.9363 21.4 38.9203 21.4C39.9043 21.4 40.6723 21.16 41.2243 20.68C41.7763 20.2 42.1843 19.648 42.4483 19.024H47.1283C46.9363 19.864 46.6603 20.596 46.3003 21.22C45.9643 21.844 45.5803 22.384 45.1483 22.84C44.7403 23.296 44.2963 23.68 43.8163 23.992C43.3363 24.28 42.8683 24.52 42.4123 24.712C41.3083 25.144 40.1443 25.36 38.9203 25.36C37.3123 25.336 35.8843 25 34.6363 24.352C34.1083 24.064 33.5803 23.704 33.0523 23.272C32.5483 22.816 32.0923 22.252 31.6843 21.58C31.3003 20.908 30.9883 20.104 30.7483 19.168C30.5083 18.232 30.3883 17.14 30.3883 15.892C30.3883 14.644 30.5083 13.552 30.7483 12.616C30.9883 11.68 31.3003 10.876 31.6843 10.204C32.0923 9.508 32.5483 8.932 33.0523 8.476C33.5803 8.02 34.1083 7.648 34.6363 7.36C35.8843 6.688 37.3123 6.328 38.9203 6.28C40.2403 6.328 41.4763 6.604 42.6283 7.108C43.1083 7.324 43.5883 7.612 44.0683 7.972C44.5723 8.308 45.0283 8.74 45.4363 9.268C45.8683 9.772 46.2403 10.384 46.5523 11.104C46.8883 11.8 47.1283 12.616 47.2723 13.552ZM42.7363 13.552C42.6163 13.168 42.4603 12.784 42.2683 12.4C42.1003 12.016 41.8603 11.668 41.5483 11.356C41.2363 11.044 40.8643 10.804 40.4323 10.636C40.0003 10.444 39.4963 10.348 38.9203 10.348C38.3443 10.348 37.8403 10.444 37.4083 10.636C36.9763 10.804 36.6043 11.044 36.2923 11.356C35.9803 11.668 35.7283 12.016 35.5363 12.4C35.3443 12.784 35.2003 13.168 35.1043 13.552H42.7363ZM57.7523 6.28C57.8243 6.28 58.0763 6.292 58.5083 6.316C58.9643 6.34 59.4923 6.448 60.0923 6.64C60.6923 6.808 61.3283 7.084 62.0003 7.468C62.6723 7.852 63.2963 8.404 63.8723 9.124C64.4483 9.844 64.9163 10.756 65.2763 11.86C65.6603 12.94 65.8523 14.284 65.8523 15.892V25H61.4603V15.892C61.4603 15.364 61.4123 14.824 61.3163 14.272C61.2203 13.72 61.0403 13.216 60.7763 12.76C60.5123 12.304 60.1403 11.932 59.6603 11.644C59.1803 11.332 58.5443 11.176 57.7523 11.176C56.9603 11.176 56.3243 11.332 55.8443 11.644C55.3643 11.932 54.9923 12.304 54.7283 12.76C54.4643 13.216 54.2843 13.72 54.1883 14.272C54.0923 14.824 54.0443 15.364 54.0443 15.892V25H49.6523V15.892C49.6523 14.284 49.8323 12.94 50.1923 11.86C50.5763 10.756 51.0563 9.844 51.6323 9.124C52.2083 8.404 52.8323 7.852 53.5043 7.468C54.1763 7.084 54.8123 6.808 55.4123 6.64C56.0123 6.448 56.5283 6.34 56.9603 6.316C57.3923 6.292 57.6563 6.28 57.7523 6.28ZM72.5398 11.032V19.06C72.6118 19.348 72.7438 19.612 72.9358 19.852C73.1038 20.044 73.3318 20.224 73.6198 20.392C73.9318 20.56 74.3278 20.644 74.8078 20.644H77.5438V25H73.1518C72.2158 24.904 71.3758 24.64 70.6318 24.208C70.0078 23.848 69.4318 23.32 68.9038 22.624C68.3998 21.904 68.1478 20.92 68.1478 19.672V1.852H72.5398V6.748H76.6798V11.032H72.5398ZM96.5271 25H92.2431V22.48L93.0351 21.436C92.6271 22.444 92.1111 23.212 91.4871 23.74C90.8631 24.268 90.2511 24.652 89.6511 24.892C88.9551 25.156 88.2351 25.312 87.4911 25.36C86.0031 25.336 84.6831 25 83.5311 24.352C83.0271 24.064 82.5351 23.704 82.0551 23.272C81.5991 22.816 81.1791 22.252 80.7951 21.58C80.4351 20.908 80.1351 20.104 79.8951 19.168C79.6791 18.232 79.5711 17.14 79.5711 15.892C79.5711 14.644 79.6911 13.552 79.9311 12.616C80.1711 11.68 80.4831 10.876 80.8671 10.204C81.2751 9.508 81.7311 8.932 82.2351 8.476C82.7631 8.02 83.2911 7.648 83.8191 7.36C85.0671 6.688 86.4951 6.328 88.1031 6.28C89.6151 6.28 90.8991 6.508 91.9551 6.964C93.0111 7.396 93.8751 8.032 94.5471 8.872C95.2431 9.688 95.7471 10.696 96.0591 11.896C96.3711 13.072 96.5271 14.416 96.5271 15.928V25ZM88.1031 10.528C87.2151 10.528 86.4951 10.708 85.9431 11.068C85.4151 11.428 85.0071 11.884 84.7191 12.436C84.4311 12.964 84.2391 13.54 84.1431 14.164C84.0471 14.788 83.9991 15.364 83.9991 15.892C83.9991 16.42 84.0471 16.996 84.1431 17.62C84.2391 18.244 84.4311 18.832 84.7191 19.384C85.0071 19.912 85.4151 20.356 85.9431 20.716C86.4951 21.076 87.2151 21.256 88.1031 21.256C88.9911 21.256 89.6991 21.076 90.2271 20.716C90.7791 20.356 91.1991 19.912 91.4871 19.384C91.7991 18.832 92.0031 18.244 92.0991 17.62C92.1951 16.996 92.2431 16.42 92.2431 15.892C92.2431 15.244 92.1951 14.608 92.0991 13.984C92.0271 13.336 91.8471 12.76 91.5591 12.256C91.2951 11.728 90.8871 11.308 90.3351 10.996C89.7831 10.684 89.0391 10.528 88.1031 10.528ZM103.302 0.7V25H98.9104V0.7H103.302ZM121.318 8.044V12.112H117.538V25H113.254V6.028C113.254 4.78 113.506 3.808 114.01 3.112C114.538 2.392 115.114 1.852 115.738 1.492C116.482 1.06 117.322 0.796 118.258 0.7H123.298V4.768H119.914C119.338 4.768 118.894 4.864 118.582 5.056C118.27 5.248 118.03 5.464 117.862 5.704C117.67 5.968 117.562 6.28 117.538 6.64V8.044H121.318ZM133.409 25.36C133.337 25.36 133.073 25.348 132.617 25.324C132.185 25.3 131.669 25.192 131.069 25C130.469 24.832 129.833 24.556 129.161 24.172C128.489 23.788 127.865 23.236 127.289 22.516C126.713 21.796 126.233 20.896 125.849 19.816C125.489 18.712 125.309 17.356 125.309 15.748V6.748H129.701V15.748C129.701 16.276 129.749 16.816 129.845 17.368C129.941 17.92 130.121 18.424 130.385 18.88C130.649 19.336 131.021 19.72 131.501 20.032C131.981 20.32 132.617 20.464 133.409 20.464C134.201 20.464 134.837 20.32 135.317 20.032C135.797 19.72 136.169 19.336 136.433 18.88C136.697 18.424 136.877 17.92 136.973 17.368C137.069 16.816 137.117 16.276 137.117 15.748V6.748H141.509V15.748C141.509 17.356 141.317 18.712 140.933 19.816C140.573 20.896 140.105 21.796 139.529 22.516C138.953 23.236 138.329 23.788 137.657 24.172C136.985 24.556 136.349 24.832 135.749 25C135.149 25.192 134.621 25.3 134.165 25.324C133.733 25.348 133.481 25.36 133.409 25.36ZM148.196 11.032V19.06C148.268 19.348 148.4 19.612 148.592 19.852C148.76 20.044 148.988 20.224 149.276 20.392C149.588 20.56 149.984 20.644 150.464 20.644H153.2V25H148.808C147.872 24.904 147.032 24.64 146.288 24.208C145.664 23.848 145.088 23.32 144.56 22.624C144.056 21.904 143.804 20.92 143.804 19.672V1.852H148.196V6.748H152.336V11.032H148.196ZM163.291 25.36C163.219 25.36 162.955 25.348 162.499 25.324C162.067 25.3 161.551 25.192 160.951 25C160.351 24.832 159.715 24.556 159.043 24.172C158.371 23.788 157.747 23.236 157.171 22.516C156.595 21.796 156.115 20.896 155.731 19.816C155.371 18.712 155.191 17.356 155.191 15.748V6.748H159.583V15.748C159.583 16.276 159.631 16.816 159.727 17.368C159.823 17.92 160.003 18.424 160.267 18.88C160.531 19.336 160.903 19.72 161.383 20.032C161.863 20.32 162.499 20.464 163.291 20.464C164.083 20.464 164.719 20.32 165.199 20.032C165.679 19.72 166.051 19.336 166.315 18.88C166.579 18.424 166.759 17.92 166.855 17.368C166.951 16.816 166.999 16.276 166.999 15.748V6.748H171.391V15.748C171.391 17.356 171.199 18.712 170.815 19.816C170.455 20.896 169.987 21.796 169.411 22.516C168.835 23.236 168.211 23.788 167.539 24.172C166.867 24.556 166.231 24.832 165.631 25C165.031 25.192 164.503 25.3 164.047 25.324C163.615 25.348 163.363 25.36 163.291 25.36ZM173.615 12.076C173.615 10.828 173.879 9.856 174.407 9.16C174.935 8.44 175.511 7.9 176.135 7.54C176.879 7.108 177.719 6.844 178.655 6.748H183.695V11.104H180.311C179.831 11.104 179.435 11.188 179.123 11.356C178.835 11.524 178.607 11.704 178.439 11.896C178.247 12.136 178.115 12.4 178.043 12.688V25H173.615V12.076ZM202.628 13.552C202.676 13.912 202.712 14.284 202.736 14.668C202.784 15.052 202.808 15.46 202.808 15.892V16.54H190.208C190.256 16.948 190.316 17.368 190.388 17.8C190.46 18.208 190.58 18.616 190.748 19.024C191.012 19.648 191.42 20.2 191.972 20.68C192.524 21.16 193.292 21.4 194.276 21.4C195.26 21.4 196.028 21.16 196.58 20.68C197.132 20.2 197.54 19.648 197.804 19.024H202.484C202.292 19.864 202.016 20.596 201.656 21.22C201.32 21.844 200.936 22.384 200.504 22.84C200.096 23.296 199.652 23.68 199.172 23.992C198.692 24.28 198.224 24.52 197.768 24.712C196.664 25.144 195.5 25.36 194.276 25.36C192.668 25.336 191.24 25 189.992 24.352C189.464 24.064 188.936 23.704 188.408 23.272C187.904 22.816 187.448 22.252 187.04 21.58C186.656 20.908 186.344 20.104 186.104 19.168C185.864 18.232 185.744 17.14 185.744 15.892C185.744 14.644 185.864 13.552 186.104 12.616C186.344 11.68 186.656 10.876 187.04 10.204C187.448 9.508 187.904 8.932 188.408 8.476C188.936 8.02 189.464 7.648 189.992 7.36C191.24 6.688 192.668 6.328 194.276 6.28C195.596 6.328 196.832 6.604 197.984 7.108C198.464 7.324 198.944 7.612 199.424 7.972C199.928 8.308 200.384 8.74 200.792 9.268C201.224 9.772 201.596 10.384 201.908 11.104C202.244 11.8 202.484 12.616 202.628 13.552ZM198.092 13.552C197.972 13.168 197.816 12.784 197.624 12.4C197.456 12.016 197.216 11.668 196.904 11.356C196.592 11.044 196.22 10.804 195.788 10.636C195.356 10.444 194.852 10.348 194.276 10.348C193.7 10.348 193.196 10.444 192.764 10.636C192.332 10.804 191.96 11.044 191.648 11.356C191.336 11.668 191.084 12.016 190.892 12.4C190.7 12.784 190.556 13.168 190.46 13.552H198.092Z"
            fill="white"
          />
        </svg>
      </router-link>
      <div class="header__actions">
        <router-link
          to="/login"
          @click="onLogin"
          class="header__btn header__btn--login btn-reset"
        >
          Login
        </router-link>
        <router-link
          to="/quiz"
          class="btn-reset header__btn header__btn--start-quiz btn btn--white"
        >
          Start my quiz
        </router-link>
      </div>
    </div>
  </header>
  <header class="header auth" v-if="token">
    <div class="header__container">
      <router-link to="/" class="header__logo">
        <svg
          width="203"
          height="26"
          viewBox="0 0 203 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.9603 15.892C11.9603 15.364 11.9243 14.824 11.8523 14.272C11.8043 13.72 11.6603 13.216 11.4203 12.76C11.1803 12.304 10.8083 11.932 10.3043 11.644C9.82427 11.332 9.14027 11.176 8.25227 11.176C7.36427 11.176 6.66827 11.332 6.16427 11.644C5.68427 11.932 5.32427 12.304 5.08427 12.76C4.84427 13.216 4.68827 13.72 4.61627 14.272C4.56827 14.824 4.54427 15.364 4.54427 15.892V25H0.152266V15.892C0.152266 14.644 0.260266 13.552 0.476266 12.616C0.716266 11.68 1.02827 10.876 1.41227 10.204C1.79627 9.508 2.22827 8.932 2.70827 8.476C3.18827 8.02 3.68027 7.648 4.18427 7.36C5.36027 6.688 6.71627 6.328 8.25227 6.28C9.76427 6.328 11.1083 6.688 12.2843 7.36C12.7883 7.648 13.2803 8.02 13.7603 8.476C14.2643 8.932 14.6963 9.508 15.0563 10.204C15.4403 10.876 15.7523 11.68 15.9923 12.616C16.2323 13.552 16.3523 14.644 16.3523 15.892V25H11.9603V15.892ZM23.7683 15.892C23.7683 15.364 23.7323 14.824 23.6603 14.272C23.6123 13.72 23.4683 13.216 23.2283 12.76C22.9883 12.304 22.6163 11.932 22.1123 11.644C21.6323 11.332 20.9483 11.176 20.0603 11.176C19.1723 11.176 18.4763 11.332 17.9723 11.644C17.4923 11.932 17.1323 12.304 16.8923 12.76C16.6523 13.216 16.4963 13.72 16.4243 14.272C16.3763 14.824 16.3523 15.364 16.3523 15.892V25H11.9603V15.892C11.9603 14.644 12.0683 13.552 12.2843 12.616C12.5243 11.68 12.8363 10.876 13.2203 10.204C13.6043 9.508 14.0363 8.932 14.5163 8.476C14.9963 8.02 15.4883 7.648 15.9923 7.36C17.1683 6.688 18.5243 6.328 20.0603 6.28C21.5723 6.328 22.9163 6.688 24.0923 7.36C24.5963 7.648 25.0883 8.02 25.5683 8.476C26.0723 8.932 26.5043 9.508 26.8643 10.204C27.2483 10.876 27.5603 11.68 27.8003 12.616C28.0403 13.552 28.1603 14.644 28.1603 15.892V25H23.7683V15.892ZM47.2723 13.552C47.3203 13.912 47.3563 14.284 47.3803 14.668C47.4283 15.052 47.4523 15.46 47.4523 15.892V16.54H34.8523C34.9003 16.948 34.9603 17.368 35.0323 17.8C35.1043 18.208 35.2243 18.616 35.3923 19.024C35.6563 19.648 36.0643 20.2 36.6163 20.68C37.1683 21.16 37.9363 21.4 38.9203 21.4C39.9043 21.4 40.6723 21.16 41.2243 20.68C41.7763 20.2 42.1843 19.648 42.4483 19.024H47.1283C46.9363 19.864 46.6603 20.596 46.3003 21.22C45.9643 21.844 45.5803 22.384 45.1483 22.84C44.7403 23.296 44.2963 23.68 43.8163 23.992C43.3363 24.28 42.8683 24.52 42.4123 24.712C41.3083 25.144 40.1443 25.36 38.9203 25.36C37.3123 25.336 35.8843 25 34.6363 24.352C34.1083 24.064 33.5803 23.704 33.0523 23.272C32.5483 22.816 32.0923 22.252 31.6843 21.58C31.3003 20.908 30.9883 20.104 30.7483 19.168C30.5083 18.232 30.3883 17.14 30.3883 15.892C30.3883 14.644 30.5083 13.552 30.7483 12.616C30.9883 11.68 31.3003 10.876 31.6843 10.204C32.0923 9.508 32.5483 8.932 33.0523 8.476C33.5803 8.02 34.1083 7.648 34.6363 7.36C35.8843 6.688 37.3123 6.328 38.9203 6.28C40.2403 6.328 41.4763 6.604 42.6283 7.108C43.1083 7.324 43.5883 7.612 44.0683 7.972C44.5723 8.308 45.0283 8.74 45.4363 9.268C45.8683 9.772 46.2403 10.384 46.5523 11.104C46.8883 11.8 47.1283 12.616 47.2723 13.552ZM42.7363 13.552C42.6163 13.168 42.4603 12.784 42.2683 12.4C42.1003 12.016 41.8603 11.668 41.5483 11.356C41.2363 11.044 40.8643 10.804 40.4323 10.636C40.0003 10.444 39.4963 10.348 38.9203 10.348C38.3443 10.348 37.8403 10.444 37.4083 10.636C36.9763 10.804 36.6043 11.044 36.2923 11.356C35.9803 11.668 35.7283 12.016 35.5363 12.4C35.3443 12.784 35.2003 13.168 35.1043 13.552H42.7363ZM57.7523 6.28C57.8243 6.28 58.0763 6.292 58.5083 6.316C58.9643 6.34 59.4923 6.448 60.0923 6.64C60.6923 6.808 61.3283 7.084 62.0003 7.468C62.6723 7.852 63.2963 8.404 63.8723 9.124C64.4483 9.844 64.9163 10.756 65.2763 11.86C65.6603 12.94 65.8523 14.284 65.8523 15.892V25H61.4603V15.892C61.4603 15.364 61.4123 14.824 61.3163 14.272C61.2203 13.72 61.0403 13.216 60.7763 12.76C60.5123 12.304 60.1403 11.932 59.6603 11.644C59.1803 11.332 58.5443 11.176 57.7523 11.176C56.9603 11.176 56.3243 11.332 55.8443 11.644C55.3643 11.932 54.9923 12.304 54.7283 12.76C54.4643 13.216 54.2843 13.72 54.1883 14.272C54.0923 14.824 54.0443 15.364 54.0443 15.892V25H49.6523V15.892C49.6523 14.284 49.8323 12.94 50.1923 11.86C50.5763 10.756 51.0563 9.844 51.6323 9.124C52.2083 8.404 52.8323 7.852 53.5043 7.468C54.1763 7.084 54.8123 6.808 55.4123 6.64C56.0123 6.448 56.5283 6.34 56.9603 6.316C57.3923 6.292 57.6563 6.28 57.7523 6.28ZM72.5398 11.032V19.06C72.6118 19.348 72.7438 19.612 72.9358 19.852C73.1038 20.044 73.3318 20.224 73.6198 20.392C73.9318 20.56 74.3278 20.644 74.8078 20.644H77.5438V25H73.1518C72.2158 24.904 71.3758 24.64 70.6318 24.208C70.0078 23.848 69.4318 23.32 68.9038 22.624C68.3998 21.904 68.1478 20.92 68.1478 19.672V1.852H72.5398V6.748H76.6798V11.032H72.5398ZM96.5271 25H92.2431V22.48L93.0351 21.436C92.6271 22.444 92.1111 23.212 91.4871 23.74C90.8631 24.268 90.2511 24.652 89.6511 24.892C88.9551 25.156 88.2351 25.312 87.4911 25.36C86.0031 25.336 84.6831 25 83.5311 24.352C83.0271 24.064 82.5351 23.704 82.0551 23.272C81.5991 22.816 81.1791 22.252 80.7951 21.58C80.4351 20.908 80.1351 20.104 79.8951 19.168C79.6791 18.232 79.5711 17.14 79.5711 15.892C79.5711 14.644 79.6911 13.552 79.9311 12.616C80.1711 11.68 80.4831 10.876 80.8671 10.204C81.2751 9.508 81.7311 8.932 82.2351 8.476C82.7631 8.02 83.2911 7.648 83.8191 7.36C85.0671 6.688 86.4951 6.328 88.1031 6.28C89.6151 6.28 90.8991 6.508 91.9551 6.964C93.0111 7.396 93.8751 8.032 94.5471 8.872C95.2431 9.688 95.7471 10.696 96.0591 11.896C96.3711 13.072 96.5271 14.416 96.5271 15.928V25ZM88.1031 10.528C87.2151 10.528 86.4951 10.708 85.9431 11.068C85.4151 11.428 85.0071 11.884 84.7191 12.436C84.4311 12.964 84.2391 13.54 84.1431 14.164C84.0471 14.788 83.9991 15.364 83.9991 15.892C83.9991 16.42 84.0471 16.996 84.1431 17.62C84.2391 18.244 84.4311 18.832 84.7191 19.384C85.0071 19.912 85.4151 20.356 85.9431 20.716C86.4951 21.076 87.2151 21.256 88.1031 21.256C88.9911 21.256 89.6991 21.076 90.2271 20.716C90.7791 20.356 91.1991 19.912 91.4871 19.384C91.7991 18.832 92.0031 18.244 92.0991 17.62C92.1951 16.996 92.2431 16.42 92.2431 15.892C92.2431 15.244 92.1951 14.608 92.0991 13.984C92.0271 13.336 91.8471 12.76 91.5591 12.256C91.2951 11.728 90.8871 11.308 90.3351 10.996C89.7831 10.684 89.0391 10.528 88.1031 10.528ZM103.302 0.7V25H98.9104V0.7H103.302ZM121.318 8.044V12.112H117.538V25H113.254V6.028C113.254 4.78 113.506 3.808 114.01 3.112C114.538 2.392 115.114 1.852 115.738 1.492C116.482 1.06 117.322 0.796 118.258 0.7H123.298V4.768H119.914C119.338 4.768 118.894 4.864 118.582 5.056C118.27 5.248 118.03 5.464 117.862 5.704C117.67 5.968 117.562 6.28 117.538 6.64V8.044H121.318ZM133.409 25.36C133.337 25.36 133.073 25.348 132.617 25.324C132.185 25.3 131.669 25.192 131.069 25C130.469 24.832 129.833 24.556 129.161 24.172C128.489 23.788 127.865 23.236 127.289 22.516C126.713 21.796 126.233 20.896 125.849 19.816C125.489 18.712 125.309 17.356 125.309 15.748V6.748H129.701V15.748C129.701 16.276 129.749 16.816 129.845 17.368C129.941 17.92 130.121 18.424 130.385 18.88C130.649 19.336 131.021 19.72 131.501 20.032C131.981 20.32 132.617 20.464 133.409 20.464C134.201 20.464 134.837 20.32 135.317 20.032C135.797 19.72 136.169 19.336 136.433 18.88C136.697 18.424 136.877 17.92 136.973 17.368C137.069 16.816 137.117 16.276 137.117 15.748V6.748H141.509V15.748C141.509 17.356 141.317 18.712 140.933 19.816C140.573 20.896 140.105 21.796 139.529 22.516C138.953 23.236 138.329 23.788 137.657 24.172C136.985 24.556 136.349 24.832 135.749 25C135.149 25.192 134.621 25.3 134.165 25.324C133.733 25.348 133.481 25.36 133.409 25.36ZM148.196 11.032V19.06C148.268 19.348 148.4 19.612 148.592 19.852C148.76 20.044 148.988 20.224 149.276 20.392C149.588 20.56 149.984 20.644 150.464 20.644H153.2V25H148.808C147.872 24.904 147.032 24.64 146.288 24.208C145.664 23.848 145.088 23.32 144.56 22.624C144.056 21.904 143.804 20.92 143.804 19.672V1.852H148.196V6.748H152.336V11.032H148.196ZM163.291 25.36C163.219 25.36 162.955 25.348 162.499 25.324C162.067 25.3 161.551 25.192 160.951 25C160.351 24.832 159.715 24.556 159.043 24.172C158.371 23.788 157.747 23.236 157.171 22.516C156.595 21.796 156.115 20.896 155.731 19.816C155.371 18.712 155.191 17.356 155.191 15.748V6.748H159.583V15.748C159.583 16.276 159.631 16.816 159.727 17.368C159.823 17.92 160.003 18.424 160.267 18.88C160.531 19.336 160.903 19.72 161.383 20.032C161.863 20.32 162.499 20.464 163.291 20.464C164.083 20.464 164.719 20.32 165.199 20.032C165.679 19.72 166.051 19.336 166.315 18.88C166.579 18.424 166.759 17.92 166.855 17.368C166.951 16.816 166.999 16.276 166.999 15.748V6.748H171.391V15.748C171.391 17.356 171.199 18.712 170.815 19.816C170.455 20.896 169.987 21.796 169.411 22.516C168.835 23.236 168.211 23.788 167.539 24.172C166.867 24.556 166.231 24.832 165.631 25C165.031 25.192 164.503 25.3 164.047 25.324C163.615 25.348 163.363 25.36 163.291 25.36ZM173.615 12.076C173.615 10.828 173.879 9.856 174.407 9.16C174.935 8.44 175.511 7.9 176.135 7.54C176.879 7.108 177.719 6.844 178.655 6.748H183.695V11.104H180.311C179.831 11.104 179.435 11.188 179.123 11.356C178.835 11.524 178.607 11.704 178.439 11.896C178.247 12.136 178.115 12.4 178.043 12.688V25H173.615V12.076ZM202.628 13.552C202.676 13.912 202.712 14.284 202.736 14.668C202.784 15.052 202.808 15.46 202.808 15.892V16.54H190.208C190.256 16.948 190.316 17.368 190.388 17.8C190.46 18.208 190.58 18.616 190.748 19.024C191.012 19.648 191.42 20.2 191.972 20.68C192.524 21.16 193.292 21.4 194.276 21.4C195.26 21.4 196.028 21.16 196.58 20.68C197.132 20.2 197.54 19.648 197.804 19.024H202.484C202.292 19.864 202.016 20.596 201.656 21.22C201.32 21.844 200.936 22.384 200.504 22.84C200.096 23.296 199.652 23.68 199.172 23.992C198.692 24.28 198.224 24.52 197.768 24.712C196.664 25.144 195.5 25.36 194.276 25.36C192.668 25.336 191.24 25 189.992 24.352C189.464 24.064 188.936 23.704 188.408 23.272C187.904 22.816 187.448 22.252 187.04 21.58C186.656 20.908 186.344 20.104 186.104 19.168C185.864 18.232 185.744 17.14 185.744 15.892C185.744 14.644 185.864 13.552 186.104 12.616C186.344 11.68 186.656 10.876 187.04 10.204C187.448 9.508 187.904 8.932 188.408 8.476C188.936 8.02 189.464 7.648 189.992 7.36C191.24 6.688 192.668 6.328 194.276 6.28C195.596 6.328 196.832 6.604 197.984 7.108C198.464 7.324 198.944 7.612 199.424 7.972C199.928 8.308 200.384 8.74 200.792 9.268C201.224 9.772 201.596 10.384 201.908 11.104C202.244 11.8 202.484 12.616 202.628 13.552ZM198.092 13.552C197.972 13.168 197.816 12.784 197.624 12.4C197.456 12.016 197.216 11.668 196.904 11.356C196.592 11.044 196.22 10.804 195.788 10.636C195.356 10.444 194.852 10.348 194.276 10.348C193.7 10.348 193.196 10.444 192.764 10.636C192.332 10.804 191.96 11.044 191.648 11.356C191.336 11.668 191.084 12.016 190.892 12.4C190.7 12.784 190.556 13.168 190.46 13.552H198.092Z"
            fill="white"
          />
        </svg>
      </router-link>
      <nav class="header__menu header-menu" :class="{ open: navOpen }">
        <ul class="header-menu__list">
          <li class="header-menu__item">
            <router-link to="/home" class="header-menu__link">
              <span class="header-menu__link-icon">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="$route.path == '/home'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M20.99 6.62a.521.521 0 00.886-.397V1.526a.522.522 0 00-.522-.522h-4.691a.521.521 0 00-.48.323.512.512 0 00.115.575l4.691 4.717zM3.11 12.12V24h7.297v-7.307h4.17V24h7.298V12.12l-9.383-9.394L3.11 12.12z" fill="#fff"/><path d="M24.856 12.153L12.867.149a.521.521 0 00-.73 0L.148 12.153a.512.512 0 00.17.834.522.522 0 00.57-.114L12.492 1.245l11.624 11.638a.542.542 0 00.73 0 .522.522 0 00.01-.73z" fill="#fff"/></svg>
                <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1501_3164)" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"><path d="M3.652 13.043v10.435h6.261v-7.304h5.218v7.304h6.26v-9.913M.521 12.522l12-12 12 12M16.695 1.565h3.652v3.652"/></g><defs><clipPath id="clip0_1501_3164"><path fill="#fff" d="M0 0h25.044v24H0z"/></clipPath></defs></svg>
              </span>
              Home
            </router-link>
          </li>
          <li class="header-menu__item">
            <router-link to="/meditation" class="header-menu__link">
              <span class="header-menu__link-icon">
                <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="$route.path == '/meditation'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M5.793 16.597A16.814 16.814 0 014.416 9.2a14.953 14.953 0 00-3.847.5.782.782 0 00-.564.845c0 .313.97 7.664 5.537 11.215a11.652 11.652 0 007.226 2.237h.72a16.017 16.017 0 01-7.695-7.399zM32.665 9.7a15.797 15.797 0 00-3.847-.5 16.814 16.814 0 01-1.377 7.397 16.08 16.08 0 01-7.648 7.383h.672c2.59.079 5.134-.709 7.227-2.237 4.567-3.55 5.505-10.948 5.536-11.214a.782.782 0 00-.563-.83z" fill="#fff"/><path d="M9.499 11.75c.047-2.63.711-5.213 1.94-7.54a17.204 17.204 0 00-3.583-1.564.798.798 0 00-.954.516c-.094.298-2.268 7.273.297 12.841a14.076 14.076 0 005.85 6.069A18.502 18.502 0 019.5 11.749zM26.33 3.084a.798.798 0 00-.954-.516c-1.248.387-2.45.912-3.581 1.564a16.893 16.893 0 011.94 7.54 18.504 18.504 0 01-3.551 10.26 14.077 14.077 0 005.85-6.07c2.564-5.49.39-12.465.296-12.778z" fill="#fff"/><path d="M17.178.22a.829.829 0 00-1.126 0c-.203.22-4.99 5.225-4.99 11.528 0 6.303 4.787 11.324 4.99 11.527a.798.798 0 001.126 0c.203-.203 4.99-5.208 4.99-11.527 0-6.32-4.787-11.309-4.99-11.528z" fill="#fff"/></svg>
                <svg width="33" height="24" viewBox="0 0 33 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M21.24 11.758c0 5.963-4.61 10.758-4.61 10.758s-4.61-4.826-4.61-10.758C12.02 5.826 16.63 1 16.63 1s4.61 4.795 4.61 10.758z" stroke="#fff" stroke-linejoin="round"/><path d="M20.103 6.348a16.137 16.137 0 015.256-2.859s2.167 6.808-.262 12.065c-2.428 5.255-8.544 6.992-8.544 6.992" stroke="#fff" stroke-linejoin="round"/><path d="M26.235 10.16a15.214 15.214 0 015.87.323s-.86 7.162-5.148 10.497c-4.288 3.334-10.404 1.536-10.404 1.536M13.156 6.47a16.2 16.2 0 00-5.41-2.98s-2.182 6.807.262 12.064c2.443 5.255 8.545 6.992 8.545 6.992" stroke="#fff" stroke-linejoin="round"/><path d="M6.901 10.175A14.909 14.909 0 001 10.482s.86 7.162 5.148 10.497c4.288 3.335 10.405 1.537 10.405 1.537a.936.936 0 000-.123" stroke="#fff" stroke-linejoin="round"/></svg>
              </span>
              Meditation
            </router-link>
          </li>
          <li class="header-menu__item">
            <router-link to="/sleep" class="header-menu__link">
              <span class="header-menu__link-icon">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="$route.path == '/sleep'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23.997 11.421a.585.585 0 00-.585-.585h-2.096l2.505-2.517a.55.55 0 00.129-.632.586.586 0 00-.538-.363H19.9a.585.585 0 000 1.17h2.095l-2.505 2.517a.55.55 0 00-.128.632.586.586 0 00.538.363h3.512a.585.585 0 00.585-.585zM18.84 6.042a.585.585 0 00-.585-.585H16.16l2.505-2.517a.55.55 0 00.129-.632.586.586 0 00-.539-.363h-3.511a.585.585 0 000 1.17h2.095l-2.505 2.517a.55.55 0 00-.129.632.586.586 0 00.539.363h3.511a.585.585 0 00.586-.585zM20.888 1.17h.925l-1.334 1.347a.55.55 0 00-.13.632.586.586 0 00.54.363h2.34a.585.585 0 000-1.171h-.924L23.639.995a.55.55 0 00.129-.632.586.586 0 00-.539-.363h-2.34a.586.586 0 000 1.17z" fill="#fff"/><path d="M22.838 15.286h.015l.014-.001a.28.28 0 01.214.082.246.246 0 01.069.165 11.314 11.314 0 01-3.387 5.126 11.692 11.692 0 01-5.674 2.675 11.823 11.823 0 01-6.268-.625 11.56 11.56 0 01-5.004-3.739 11.195 11.195 0 01-2.266-5.742c-.2-2.082.192-4.177 1.134-6.054a11.425 11.425 0 014.204-4.584A11.771 11.771 0 0111.927.832h.007a.17.17 0 01.077.016.154.154 0 01.057.046.131.131 0 01.022.124h0l-.002.006a10.814 10.814 0 00-.336 5.098 10.91 10.91 0 002.044 4.697 11.19 11.19 0 003.98 3.289 11.429 11.429 0 005.062 1.178z" fill="#fff" stroke="#fff"/></svg>
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23.998 11.42a.585.585 0 00-.585-.585h-2.096l2.505-2.517a.55.55 0 00.129-.632.586.586 0 00-.538-.363H19.9a.585.585 0 000 1.17h2.095l-2.505 2.517a.55.55 0 00-.128.632.585.585 0 00.538.363h3.512a.586.586 0 00.585-.585zM18.84 6.042a.585.585 0 00-.586-.585H16.16l2.505-2.517a.55.55 0 00.129-.632.586.586 0 00-.539-.363h-3.511a.585.585 0 000 1.17h2.095l-2.505 2.517a.55.55 0 00-.129.632.586.586 0 00.539.363h3.511a.585.585 0 00.586-.585zM20.888 1.17h.925l-1.334 1.347a.55.55 0 00-.13.632.586.586 0 00.54.363h2.34a.585.585 0 000-1.171h-.924L23.639.995a.55.55 0 00.129-.632.586.586 0 00-.539-.363h-2.34a.586.586 0 000 1.17z" fill="#fff"/><path d="M22.838 15.285h.015l.014-.001a.28.28 0 01.214.082.246.246 0 01.069.165 11.315 11.315 0 01-3.387 5.126 11.693 11.693 0 01-5.674 2.675 11.824 11.824 0 01-6.268-.625 11.561 11.561 0 01-5.004-3.739 11.195 11.195 0 01-2.266-5.742c-.2-2.082.192-4.177 1.134-6.054a11.425 11.425 0 014.204-4.584A11.771 11.771 0 0111.927.831h.007a.17.17 0 01.077.016.154.154 0 01.057.046.131.131 0 01.022.124h0l-.002.006a10.814 10.814 0 00-.336 5.098c.297 1.702.997 3.31 2.044 4.697a11.19 11.19 0 003.98 3.289 11.427 11.427 0 005.062 1.178z" stroke="#fff"/></svg>
              </span>
              Sleep
            </router-link>
          </li>
          <li class="header-menu__item">
            <router-link to="/therapy" class="header-menu__link">
              <span class="header-menu__link-icon">
                <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="$route.path == '/therapy'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19.061 8.41c0-5-4.75-7.91-9.06-7.91a9.41 9.41 0 00-9.5 9.56c0 3.05 1 5.9 4 7.68v5.76h10V20c2 0 3-.13 3.72-.83.9-.9.81-4.69.81-4.69h1.5a.79.79 0 00.58-.31 1.31 1.31 0 00.1-.63c.12-1.54-2.15-4.33-2.15-5.13z" stroke="#fff" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.529 10.334c.602 1.044 1.182 2.05 1.182 3.266 0 1.02-.6 1.4-1.14 1.41h-1c0 1.19-.22 3.72-1 4.53s-1.83 1-3.57 1v3a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-5.48c-2.65-1.72-4-4.4-4-8a9.92 9.92 0 0110-10.06c4.7 0 9.56 3.14 9.56 8.41.255.688.615 1.312.968 1.924zm-6.925-1.667h1.188a.209.209 0 01.208.208v1.25a.209.209 0 01-.208.209h-1.188c-.08.332-.188.657-.325.97l.834.834a.213.213 0 010 .296l-1.18 1.179a.213.213 0 01-.296 0l-.833-.833a5.775 5.775 0 01-.97.325v1.187a.208.208 0 01-.209.209h-1.25a.209.209 0 01-.208-.209v-1.187a5.773 5.773 0 01-.971-.325l-.833.833a.213.213 0 01-.296 0l-1.18-1.18a.209.209 0 010-.295l.834-.833a5.768 5.768 0 01-.325-.971H5.208A.208.208 0 015 10.126v-1.25a.208.208 0 01.208-.209h1.188c.08-.332.188-.657.325-.97l-.833-.834a.208.208 0 010-.296l1.179-1.179a.212.212 0 01.295 0l.834.833c.312-.139.637-.246.97-.32V4.708a.208.208 0 01.209-.209h1.25a.208.208 0 01.208.209V5.9c.334.075.66.182.971.321l.833-.833a.212.212 0 01.296 0l1.18 1.18a.213.213 0 010 .295l-.834.833c.139.313.248.638.325.971zm-4.53 2.22a1.667 1.667 0 101.852-2.773 1.667 1.667 0 00-1.852 2.772z" fill="#fff"/></svg>
                <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1501_3001)" stroke="#fff"><path d="M19.06 8.41c0-5-4.75-7.91-9.06-7.91a9.41 9.41 0 00-9.5 9.56c0 3.05 1 5.9 4 7.68v5.76h10V20c2 0 3-.13 3.72-.83.9-.9.81-4.69.81-4.69h1.5a.789.789 0 00.58-.31c.085-.199.12-.415.1-.63.12-1.54-2.15-4.33-2.15-5.13z" stroke-linejoin="round"/><g clip-path="url(#clip1_1501_3001)"><path d="M13.532 9.229l1.104-.622-1.09-1.857-1.097.621a3.7 3.7 0 00-1.359-.778V5.357H8.91V6.6a3.707 3.707 0 00-1.352.779L6.453 6.75l-1.09 1.857 1.105.629a3.393 3.393 0 000 1.528l-1.105.629 1.09 1.857 1.098-.621c.39.354.853.62 1.359.778v1.236h2.18V13.4a3.605 3.605 0 001.352-.779l1.104.629 1.09-1.857-1.104-.629a3.42 3.42 0 000-1.535z" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 11.429c.803 0 1.454-.64 1.454-1.429S10.804 8.571 10 8.571c-.802 0-1.453.64-1.453 1.429s.65 1.429 1.453 1.429z" stroke-miterlimit="10"/></g></g><defs><clipPath id="clip0_1501_3001"><path fill="#fff" d="M0 0h21.71v24H0z"/></clipPath><clipPath id="clip1_1501_3001"><path fill="#fff" transform="translate(5 5)" d="M0 0h10v10H0z"/></clipPath></defs></svg>
              </span>
              Therapy
            </router-link>
          </li>
          <li class="header-menu__item">
            <router-link to="/sounds" class="header-menu__link">
              <span class="header-menu__link-icon">
                <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="$route.path == '/music'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6.31 4.542a.5.5 0 00-.31.46v11.5H3.5a3.5 3.5 0 100 7 3.6 3.6 0 003.5-3.5V8.841l10-4.09v7.75h-2.5a3.5 3.5 0 100 7 3.6 3.6 0 003.5-3.5V.502a.5.5 0 00-.69-.46l-11 4.5z" fill="#fff"/></svg>
                <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1501_3150)" stroke="#fff" stroke-linejoin="round"><path d="M6.5 20a3.1 3.1 0 01-3 3 3 3 0 010-6h3v3zM17.5 16a3.1 3.1 0 01-3 3 3 3 0 010-6h3v3z"/><path d="M6.5 17V5l11-4.5V13M6.5 8.5l11-4.5"/></g><defs><clipPath id="clip0_1501_3150"><path fill="#fff" d="M0 0h18v23.5H0z"/></clipPath></defs></svg>
              </span>
              Sounds
            </router-link>
          </li>
        </ul>
        <div class="header__actions">
          <button class="header__btn header__btn--search btn-reset">
            <span class="header__link-icon">
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_6116_7076)" stroke="#fff" stroke-linejoin="round"><path d="M8.147 15.814a7.667 7.667 0 100-15.334 7.667 7.667 0 000 15.334z"/><path d="M13.57 13.57l8.951 8.951" stroke-linecap="round"/></g><defs><clipPath id="clip0_6116_7076"><path fill="#fff" d="M0 0h23v23H0z"/></clipPath></defs></svg>
            </span>

            <div class="dropdown search">
              <div class="search__wrapper">
                <form @submit.prevent="onSearch">
                  <input
                    v-model="searchText"
                    class="search__input"
                    placeholder="Search by ..."
                  />
                </form>

                <div class="search__tags">
                  <button
                    @click="onTagSelect(tag)"
                    v-for="(tag, i) in tags"
                    :key="i"
                    class="search__tag"
                    :class="{ active: selectedTags.includes(tag) }"
                  >
                    {{ tag }}
                  </button>
                </div>
              </div>
            </div>
          </button>
          <router-link
            to="/settings"
            class="header__btn header__btn--settings btn-reset"
          >
            <span class="header__link-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-if="$route.path == '/settings'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23.5 10h-2.85c-.2-.79-.45-1.67-.78-2.33l2.03-2.03c.2-.2.2-.51 0-.71L19.07 2.1c-.2-.2-.51-.2-.71 0l-2.03 2.03c-.67-.32-1.54-.58-2.33-.78V.5c0-.28-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5v2.86c-.79.2-1.67.45-2.33.78L5.64 2.11c-.2-.2-.51-.2-.71 0L2.1 4.94c-.2.19-.2.51 0 .71l2.03 2.03c-.32.66-.58 1.54-.78 2.33H.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h2.85c.2.79.46 1.67.78 2.33L2.1 18.37c-.2.19-.2.51 0 .71l2.83 2.83c.19.19.52.19.71 0l2.03-2.03c.66.32 1.54.58 2.33.78v2.85c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-2.85c.79-.2 1.67-.46 2.33-.78l2.03 2.03c.2.2.51.2.71 0l2.83-2.83c.2-.2.2-.51 0-.71l-2.03-2.03c.32-.66.58-1.54.78-2.33h2.85c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5V10zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" fill="#fff"/></svg>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-else="" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M20.25 13.5h3.25v-3h-3.25a11.85 11.85 0 00-1-2.92l2.3-2.3-2.83-2.83-2.3 2.3a11.85 11.85 0 00-2.92-1V.5h-3v3.25a11.85 11.85 0 00-2.92 1l-2.3-2.3-2.83 2.83 2.3 2.3a11.85 11.85 0 00-1 2.92H.5v3h3.25a11.85 11.85 0 001 2.92l-2.3 2.3 2.83 2.83 2.3-2.3c.926.46 1.907.795 2.92 1v3.25h3v-3.25a11.85 11.85 0 002.92-1l2.3 2.3 2.83-2.83-2.3-2.3a11.85 11.85 0 001-2.92v0z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 16.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'header__link-icon--hover'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23.5 10h-2.85c-.2-.79-.45-1.67-.78-2.33l2.03-2.03c.2-.2.2-.51 0-.71L19.07 2.1c-.2-.2-.51-.2-.71 0l-2.03 2.03c-.67-.32-1.54-.58-2.33-.78V.5c0-.28-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5v2.86c-.79.2-1.67.45-2.33.78L5.64 2.11c-.2-.2-.51-.2-.71 0L2.1 4.94c-.2.19-.2.51 0 .71l2.03 2.03c-.32.66-.58 1.54-.78 2.33H.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h2.85c.2.79.46 1.67.78 2.33L2.1 18.37c-.2.19-.2.51 0 .71l2.83 2.83c.19.19.52.19.71 0l2.03-2.03c.66.32 1.54.58 2.33.78v2.85c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-2.85c.79-.2 1.67-.46 2.33-.78l2.03 2.03c.2.2.51.2.71 0l2.83-2.83c.2-.2.2-.51 0-.71l-2.03-2.03c.32-.66.58-1.54.78-2.33h2.85c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5V10zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" fill="#fff"/></svg>
            </span>
            <div class="header__btn-name">Settings</div>
          </router-link>
          <router-link
            to="/profile/library"
            class="header__btn header__btn--account btn-reset"
          >
            <span class="header__link-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-if="$route.path == '/profile/library'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="12" cy="12" r="11.5" stroke="#fff"/><path d="M11.84 12.5a3 3 0 100-6 3 3 0 000 6z" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.18 17.5H6.5a5.35 5.35 0 0110.68 0z" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-else="" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="12" cy="12" r="11.5" stroke="#fff"/><path d="M11.84 12.5a3 3 0 100-6 3 3 0 000 6z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.18 17.5H6.5a5.35 5.35 0 0110.68 0z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'header__link-icon--hover'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="12" cy="12" r="11.5" stroke="#fff"/><path d="M11.84 12.5a3 3 0 100-6 3 3 0 000 6z" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.18 17.5H6.5a5.35 5.35 0 0110.68 0z" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>
              <!-- <svg width="42" height="24" viewBox="0 0 42 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'profile--desktop'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="12" cy="12" r="11.5" stroke="#fff"/><path d="M11.84 12.5a3 3 0 100-6 3 3 0 000 6z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.18 17.5H6.5a5.35 5.35 0 0110.68 0z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path d="M34 14.19l-3.97-3.971a.747.747 0 00-1.059 0 .753.753 0 000 1.063l4.497 4.5c.284.284.74.29 1.034.021l4.529-4.518a.75.75 0 000-1.063.747.747 0 00-1.06 0L34 14.191z" fill="#fff"/></svg> -->
            </span>
            <div class="header__btn-name">Profile</div>
            <div class="dropdown">
              <router-link to="/profile/library" class="dropdown__item">
                Library
              </router-link>
              <router-link to="/profile/achievements" class="dropdown__item">
                Achievements
              </router-link>
              <router-link to="/profile/notes" class="dropdown__item">
                Notes
              </router-link>
              <router-link to="/profile/worksheets" class="dropdown__item">
                Worksheets
              </router-link>
            </div>
          </router-link>
        </div>
      </nav>
      <button
        class="btn-reset header__btn-menu"
        @click="
          () => {
            navOpen = !navOpen
            bodyClass(true, 'overflow')
          }
        "
        :class="{ active: navOpen }"
      >
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-if="navOpen == false" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19.374.615H.627M19.374 5.538H.627M19.374 10.461H.627M19.374 15.385H.627" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-else="" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M7.5 7.5l9 9M16.5 7.5l-9 9M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5z" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>
  </header>
</template>

<script>
import { getAllTags } from '@/services/other.service'
import { mapState } from 'vuex'
export default {
  name: 'Header',
  props: ['user'],
  data() {
    return {
      navOpen: false,
      tags: [],
      searchText: '',
      selectedTags: [],
    }
  },
  computed: {
    ...mapState(['token']),
  },
  created() {
    if (this.token) {
      if (this.$route.query.tags)
        this.selectedTags = this.$route.query.tags.split(',')
      if (this.$route.query.s) this.searchText = this.$route.query.s
      getAllTags()
        .then((res) => {
          this.tags = res.tags.slice(0, 12)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  methods: {
    bodyClass(addRemoveClass, className) {
      const bodyClassList = document.body.classList

      if (this.navOpen === addRemoveClass) {
        bodyClassList.add(className)
      } else {
        bodyClassList.remove(className)
      }
    },
    onLogin() {
      if (localStorage.getItem('isQuiz')) {
        localStorage.removeItem('isQuiz')
      }
    },
    onSearch() {
      let q = {}
      if (this.searchText) q.s = this.searchText
      if (this.selectedTags && this.selectedTags.length)
        q.tags = this.selectedTags.join(',')
      this.$router.push({
        name: 'SearchResult',
        query: q,
      })
    },
    onTagSelect(tag) {
      if (this.selectedTags.includes(tag))
        this.selectedTags = this.selectedTags.filter((i) => i !== tag)
      else this.selectedTags.push(tag)
      this.onSearch()
    },
  },
  mounted() {
    this.bodyClass(true, 'overflow')
  },
  destroyed() {
    this.bodyClass(false, 'overflow')
  },
}
</script>

<style lang="scss">
@import '../assets/common';

.header {
  z-index: 2;
  border-bottom: 1px solid rgba(#fff, 0.1);

  &__container {
    display: flex;
    align-items: center;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
    max-width: 100%;

    @media (max-width: 991px) {
      justify-content: space-between;
      padding: 20px 24px;
    }

    @media (min-width: 992px) {
      padding: 28px 36px;
    }
  }

  &__logo {
    position: relative;
    z-index: 1;

    @media (max-width: 991px) {
      display: flex;
      align-items: center;

      svg {
        max-width: 137px;
      }
    }

    @media (min-width: 992px) {
      margin-right: 48px;
    }
  }

  &__actions {
    display: flex;

    .header.no-auth & {
      flex-grow: 1;
      align-items: center;
      justify-content: flex-end;

      @media (max-width: 991px) {
      }
    }

    .header.auth & {
      @media (max-width: 991px) {
        flex-direction: column;

        .header__btn {
          &--search {
            display: none;
          }

          &:not(:last-child) {
            margin-bottom: 35px;
          }
        }
      }

      @media (min-width: 992px) {
        margin-left: auto;
      }
    }
  }

  &__btn-menu {
    display: none;

    @media (max-width: 991px) {
      display: flex;
      align-items: center;
      height: 16px;
      width: 20px;
      cursor: pointer;
      z-index: 3;
    }
  }

  &__btn {
    position: relative;
    transition: 0.4s ease;

    .header.no-auth & {
      &:not(:last-child) {
        margin-right: 24px;
      }
    }

    @media (max-width: 991px) {
      display: flex;
    }

    @media (min-width: 992px) {
      &:not(:last-child) {
        margin-right: 24px;
      }

      &:hover {
        .header__link-icon--hover {
          opacity: 1;
          visibility: visible;
          transition: 0.3s ease;
        }
      }
    }

    &--account {
      cursor: default !important;
      .header__btn-icon {
        display: inline-flex;
        align-items: center;

        svg {
          &:first-child {
            margin-right: 3px;
          }
        }
      }

      &:hover {
        @media (min-width: 992px) {
          .dropdown {
            opacity: 1;
            visibility: visible;
            user-select: inherit;
          }
        }
      }
    }

    &--login {
      font-weight: 600;
      font-weight: 800;
      font-size: 16px;
      margin-right: 55px;
      color: var(--color-white);
      cursor: pointer;

      &:hover {
        font-weight: 800;
      }

      @media (max-width: 768px) {
        display: none;
      }
    }

    &--start-quiz {
      font-weight: 700;
      font-size: 16px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      flex: 1 0 160px;
      width: 100%;
      max-width: 160px;
      border-radius: 58px;
      padding: 13.5px 0 !important;
      color: var(--color-main);

      @media (max-width: 768px) {
        .header.no-auth & {
          margin-left: 10px;
        }

        font-size: 14px !important;
        padding: 10px 0 !important;
        flex: 1 0 140px;
        max-width: 140px;
      }
    }

    &--search {
      @media (min-width: 992px) {
        &:hover {
          svg {
            stroke-width: 1.5px;
            transition: 0.3s ease;
          }
          .dropdown {
            opacity: 1;
            visibility: visible;
            user-select: inherit;
          }
        }
      }
    }
  }
  &__btn-name {
    @media (max-width: 991px) {
      font-weight: 400;
      font-size: 16px;
      color: var(--color-white);
    }

    @media (min-width: 992px) {
      display: none;
    }
  }
  &__link-icon {
    &--hover {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      visibility: hidden;
    }

    @media (max-width: 991px) {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 24px;
      margin-right: 16px;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.header-menu {
  @media (min-width: 992px) {
    display: flex;
    width: 100%;
  }

  @media (max-width: 991px) {
    position: fixed;
    top: 0;
    bottom: 0;
    left: -100%;
    padding: 74px 24px 24px;
    opacity: 0;
    background-color: var(--color-main);
    visibility: hidden;
    user-select: none;
    z-index: 2;
    transition: 0.4s ease;
    overflow: auto;

    &.open {
      left: 0;
      right: 0;
      opacity: 1;
      visibility: visible;
      transition: 0.4s ease;

      .header-menu__item {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  &__list {
    display: flex;

    @media (max-width: 991px) {
      flex-direction: column;
    }

    @media (min-width: 992px) {
      align-items: center;
    }
  }

  &__item {
    @media (max-width: 991px) {
      opacity: 0;
      visibility: hidden;
      transition: 0.4s ease;
      margin-bottom: 35px;
    }

    @media (min-width: 992px) {
      &:not(:last-child) {
        margin-right: 24px;
      }
    }
    &.active {
      .header-menu__link {
        font-weight: 800;
      }
    }
  }

  &__link {
    font-weight: 400;
    color: var(--color-white);

    &.active {
      font-weight: 800;

      @media (max-width: 991px) {
        font-weight: 700;
      }
    }

    @media (max-width: 991px) {
      display: flex;
      align-items: center;
      font-size: 16px;
    }

    @media (min-width: 992px) {
      font-size: 14px;
    }
  }
  &__link-icon {
    display: none;

    @media (max-width: 991px) {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 24px;
      margin-right: 16px;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.dropdown {
  @media (max-width: 991px) {
    display: none;
  }

  @media (min-width: 992px) {
    position: absolute;
    bottom: -171px;
    right: 0;
    min-width: 132px;
    padding: 16px;
    border-radius: 12px;
    background-color: var(--color-main);
    text-align: left;
    opacity: 0;
    visibility: hidden;
    user-select: none;
    transition: 0.4s ease;

    &.search {
      top: 32px;
      bottom: unset;
      right: -15px;
    }

    &::before {
      content: '';
      position: absolute;
      top: -20px;
      right: 0;
      left: 0;
      width: 100%;
      height: 20px;
      background: transparent;
    }

    &__item {
      display: inline-block;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      transition: 0.4s ease;

      &:not(:last-child) {
        margin-bottom: 16px;
      }

      &:not(.active) {
        color: var(--color-white);
      }

      &.active {
        color: var(--color-green);
      }

      &:hover,
      &:focus {
        color: var(--color-green);
      }
    }
  }
}

.search {
  &__input {
    border: 1px solid rgba(#fff, 0.1);
    border-radius: 58px;
    height: 52px;
    width: 327px;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    background: inherit;
    color: var(--color-white);
    outline: none;

    &::placeholder {
      color: rgba(#fff, 0.4);
    }
  }

  &__wrapper {
    margin: 4px 8px 12px;
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    margin-top: 24px;
    column-gap: 8px;
    row-gap: 12px;
  }

  &__tag {
    background: rgba(#fff, 0.1);
    border-radius: 18px;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: var(--color-white);
    padding: 9px 20px;
    border: none;
    outline: none;
    transition: opacity 300ms ease-in-out;

    &.active {
      background: #71b280;
    }

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
